import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth';
import { useI18n } from '../i18n';

export function AuthBtn() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { t } = useI18n();

  return (
    <button
      className={`global-ctrl-btn auth-btn icon-btn${user ? ' auth-btn--logged' : ''}`}
      onClick={() => navigate(user ? '/profile' : '/auth')}
      title={user ? user.nickname : t.auth.loginBtn}
    >
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
      </svg>
      {!user && <span className="auth-nick">{t.auth.loginBtn}</span>}
    </button>
  );
}
